import React from "react";
import { Box, Card, Divider, Grid, Typography } from '@curves/ui-base';

import { Tablenization } from "@Local/Components";
const ProductSectionByRead = props => {
	const { items } = props;
	// 計算總計
	const calculateTotal = () => {
		if (!items || !Array.isArray(items)) {
			return 0;
		}
		return items.reduce((total, item) => {
			return total + item.salePrice * item.quantity;
		}, 0);
	};
	const totalAmount = calculateTotal();
	const headerRow = [
		{
			cellKey: "productName",
			headerLabel: "商品",
		},
		{
			cellKey: "salePrice",
			headerLabel: "單價",
		},
		{
			cellKey: "quantity",
			headerLabel: "盒數",
		},
		{
			cellKey: "total",
			headerLabel: "總計",
		},
	];
	return (
		<React.Fragment>
			<Card>
				<Card.CardHeader
					title={
						<Typography variant="body-1" className="font-weight-900">
							訂購商品
						</Typography>
					}
					className="bg-black"
				/>
				<Card.CardContent className="p-4">
					<Box className="scroll-arrow-container overview">
						<Tablenization cardProps={{ className: "underline-table" }} isPagination>
							<Tablenization.TableRowHeader headerRow={headerRow} className="" color="font-color-5" cellWidth={null} />
							<Tablenization.TableRowBody
								headerRow={headerRow}
								rowsData={
									items?.map(item => ({
										productName: item.productName,
										salePrice: item.salePrice,
										quantity: item.quantity,
										total: item.salePrice * item.quantity,
									})) || []
								}
								children={null}
								rowOnClick={() => {}}
								bodyRowHeight={null}
								cellWidth={null}
								alertProps={{ text: "尚無資料" }}
							/>
						</Tablenization>
					</Box>
					<Divider />
					{/* 合計區域 */}
					<Grid className="mt-2" spacing={6}>
						<Grid item md={11}>
							<Box className="column" style={{ textAlign: "right" }}>
								<Typography variant="h5" className="text-primary mb-1 font-weight-900">
									合計:$ {totalAmount.toLocaleString()}
								</Typography>
								<Typography variant="body2" className="text-muted">
									售價已包含5%加值營業稅及運費(僅配送台灣本島)
								</Typography>
							</Box>
						</Grid>
					</Grid>
				</Card.CardContent>
			</Card>
		</React.Fragment>
	);
};
export default ProductSectionByRead;
